export const congressConstants = {
    ADDPARTICIPANS_REQUEST: 'ADD_PARTICIPANS_REQUEST',
    ADDPARTICIPANS_SUCCESS: 'ADD_PARTICIPANS_SUCCESS',
    ADDPARTICIPANS_FAILURE: 'ADD_PARTICIPANS_FAILURE',
 }